import { blog, website } from '@getpopsure/private-constants';
import { TFunction } from 'next-i18next';

const news = (t: TFunction) => [
  {
    title: t('aboutus:section.news.first.title'),
    description: t('aboutus:section.news.first.description'),
    image: '/static/about-us/news/why-we-dont-require-degrees.png',
    imageAlt: t('aboutus:section.news.first.imageAlt'),
    link: `${blog.base}degrees-are-outdated/`,
  },
  {
    title: t('aboutus:section.news.second.title'),
    description: t('aboutus:section.news.second.description'),
    image: '/static/about-us/news/transparency-through-tech.png',
    imageAlt: t('aboutus:section.news.second.imageAlt'),
    link: `${website.base}/feather-in-depth/management-and-engineering-at-feather-in-2024`,
  },
  {
    title: t('aboutus:section.news.third.title'),
    description: t('aboutus:section.news.third.description'),
    image: '/static/about-us/news/hack-day.png',
    imageAlt: t('aboutus:section.news.third.imageAlt'),
    link: `${website.base}/feather-in-depth/hack-days-at-feather`,
  },
];

export default news;
